<template>
    <option value="wired">wired</option>
    <option value="solar">solar</option>
</template>
